export enum ForetagTransactions {
  MET037 = 'MET037',
  MET038 = 'MET038',
  MET039 = 'MET039',
  MET0242 = 'MET0242',
  MET0243 = 'MET0243',
  MET030 = 'MET030',
  MET031 = 'MET031',
  MET032 = 'MET032',
  MET033 = 'MET033',
  MET034 = 'MET034',
  MET035 = 'MET035',
  FINFO_BYGGKART_L = 'FINFO_BYGGKART_L',
  MET0241 = 'MET0241',
  MET036 = 'MET036',
  XML0316 = 'XML0316',
  XML100 = 'XML100',
  XML0315 = 'XML0315',
  XML0314 = 'XML0314',
  XML0313 = 'XML0313',
  XML0312 = 'XML0312',
  MET0511 = 'MET0511',
  XML0311 = 'XML0311',
  MET0512 = 'MET0512',
  XML0310 = 'XML0310',
  METORG01 = 'METORG01',
  XML060 = 'XML060',
  XML061 = 'XML061',
  XML062 = 'XML062',
  XML100_WGS = 'XML100_WGS',
  MET040 = 'MET040',
  MET041 = 'MET041',
  MET042 = 'MET042',
  METAGRA = 'METAGRA',
  XML0317 = 'XML0317',
  XML0722 = 'XML0722',
  AGARFORTECKNING = 'AGARFORTECKNING',
  MET0901 = 'MET0901',
  XML0721 = 'XML0721',
  XML076 = 'XML076',
  FINFO_AKT001 = 'FINFO_AKT001',
  XML0201 = 'XML0201',
  XML0200 = 'XML0200',
  XML070 = 'XML070',
  XML074 = 'XML074',
  XML072 = 'XML072',
  MET0781 = 'MET0781',
  FINFO_KART08 = 'FINFO_KART08',
  MET0782 = 'MET0782',
  METFBF02 = 'METFBF02',
  MET0783 = 'MET0783',
  MET0381 = 'MET0381',
  METAGLATA = 'METAGLATA',
  MET012 = 'MET012',
  MET090 = 'MET090',
  XML000 = 'XML000',
  XML0412 = 'XML0412',
  MET0411 = 'MET0411',
  XML0411 = 'XML0411',
  MET0412 = 'MET0412',
  METFBF01 = 'METFBF01',
  LMWS_TOTAL01 = 'LMWS_TOTAL01',
  XML080 = 'XML080',
  LGH002 = 'LGH002',
  MET026 = 'MET026',
  FINFO_KART11 = 'FINFO_KART11',
  FINFO_KART10 = 'FINFO_KART10',
  MET028 = 'MET028',
  MET029 = 'MET029',
  FINFO_KART18 = 'FINFO_KART18',
  MET020 = 'MET020',
  MET021 = 'MET021',
  FINFO_KART16 = 'FINFO_KART16',
  MET022 = 'MET022',
  MET023 = 'MET023',
  MET024 = 'MET024',
  MET025 = 'MET025',
  XML0701 = 'XML0701',
  MET0401 = 'MET0401',
  MET0402 = 'MET0402',
  XML0783 = 'XML0783',
  XML014 = 'XML014',
  XML0782 = 'XML0782',
  INHAV_TAXREG = 'INHAV_TAXREG',
  MET0403 = 'MET0403',
  XML0781 = 'XML0781',
  XML0142 = 'XML0142',
  XML090 = 'XML090',
  XML0141 = 'XML0141',
  XML0381 = 'XML0381',
  MET074 = 'MET074',
  MET0200 = 'MET0200',
  MET0201 = 'MET0201',
  MET076 = 'MET076',
  XML0901 = 'XML0901',
  MET0316 = 'MET0316',
  XML023 = 'XML023',
  MET0317 = 'MET0317',
  XML024 = 'XML024',
  XML021 = 'XML021',
  XML0512 = 'XML0512',
  XML0511 = 'XML0511',
  XML022 = 'XML022',
  MET0312 = 'MET0312',
  MET0313 = 'MET0313',
  MET070 = 'MET070',
  XML028 = 'XML028',
  MET0314 = 'MET0314',
  XML025 = 'XML025',
  MET0315 = 'MET0315',
  MET072 = 'MET072',
  XML026 = 'XML026',
  XML020 = 'XML020',
  FINFO_ORTOKART03 = 'FINFO_ORTOKART03',
  FINFO_ORTOKART02 = 'FINFO_ORTOKART02',
  FINFO_ORTOKART01 = 'FINFO_ORTOKART01',
  MET0310 = 'MET0310',
  XML029 = 'XML029',
  MET0311 = 'MET0311',
  MET000 = 'MET000',
  MET0701 = 'MET0701',
  XML034 = 'XML034',
  XML035 = 'XML035',
  XML0402 = 'XML0402',
  XML032 = 'XML032',
  XML033 = 'XML033',
  XML0401 = 'XML0401',
  MET080 = 'MET080',
  XML038 = 'XML038',
  XML039 = 'XML039',
  XML036 = 'XML036',
  XML0243 = 'XML0243',
  XML037 = 'XML037',
  XML0242 = 'XML0242',
  XML0241 = 'XML0241',
  METAGADR = 'METAGADR',
  XML030 = 'XML030',
  XML031 = 'XML031',
  METV01 = 'METV01',
  MET051 = 'MET051',
  MET0221 = 'MET0221',
  MET052 = 'MET052',
  MET0222 = 'MET0222',
  MET054 = 'MET054',
  MET056 = 'MET056',
  XML0725 = 'XML0725',
  MET100_WGS = 'MET100_WGS',
  XML0724 = 'XML0724',
  METB02 = 'METB02',
  METB03 = 'METB03',
  MET050 = 'MET050',
  FINFO_KARTOVBOSTAD = 'FINFO_KARTOVBOSTAD',
  XML041 = 'XML041',
  METLGH01 = 'METLGH01',
  XML042 = 'XML042',
  METB01 = 'METB01',
  XML040 = 'XML040',
  FINFO_KARTOVBYGG = 'FINFO_KARTOVBYGG',
  METADRL = 'METADRL',
  MET062 = 'MET062',
  MET100 = 'MET100',
  XML056 = 'XML056',
  MET0724 = 'MET0724',
  MET0725 = 'MET0725',
  XML054 = 'XML054',
  MET0721 = 'MET0721',
  XML0222 = 'XML0222',
  MET060 = 'MET060',
  MET061 = 'MET061',
  MET0722 = 'MET0722',
  XML0221 = 'XML0221',
  XMLORG01 = 'XMLORG01',
  METAGF = 'METAGF',
  XML052 = 'XML052',
  XML050 = 'XML050',
  XML051 = 'XML051',
  IPM_SYNA_LEFI = 'IPM_SYNA_LEFI',
  IPM_SYNA_GRUFO = 'IPM_SYNA_GRUFO',
}
